import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import Content from './Content';

const ContentWithContext = (props) => {
  const {
    setModalCollection,
  } = useModalContext();

  return (
    <WizardModalWrapperLayout>
      <Content {...props} setCollection={setModalCollection} />
    </WizardModalWrapperLayout>
  );
};

export default ContentWithContext;
